// Shared option sets and helpers for events, news and reviews.

export const MOOD_OPTIONS = [
  "Chill",
  "Party",
  "Creative",
  "Romantic",
  "Adventure",
  "Music",
  "Social",
  "Networking",
];

export const GENRE_GROUPS = [
  {
    label: "Music",
    options: [
      "House",
      "Techno",
      "Hip-Hop",
      "Reggae",
      "Pop",
      "Rock",
      "Jazz",
      "Electronic",
      "Drum & Bass",
    ],
  },
  {
    label: "Workshops",
    options: ["Art Workshop", "Chill Workshop", "Food Workshop", "Creative Workshop"],
  },
];

export const GENRE_OPTIONS = GENRE_GROUPS.flatMap((group) => group.options);

// Backward compatibility: prefer the new array field, fall back to the legacy
// single string field. Existing demo data (genre: "Techno", mood: "Chill")
// keeps working without any migration.
export const resolveList = (arrayField, legacyField) => {
  if (Array.isArray(arrayField)) return arrayField.filter(Boolean);
  if (typeof legacyField === "string" && legacyField.trim()) return [legacyField.trim()];
  return [];
};

// Toggle a value inside a selection array (used by chip multi-selects).
export const toggleInList = (list, value) =>
  list.includes(value) ? list.filter((item) => item !== value) : [...list, value];

// Event moderation status. Imported drafts start as "draft" and only become
// publicly visible once an admin approves them.
export const EVENT_STATUS = {
  DRAFT: "draft",
  APPROVED: "approved",
  REJECTED: "rejected",
};

// Backward compatibility: events created before this feature have no `status`
// field. Treat them as already approved so nothing currently live disappears.
export const resolveStatus = (event) => event?.status || EVENT_STATUS.APPROVED;
